import { render, staticRenderFns } from "./EventTiers.vue?vue&type=template&id=65781c56&scoped=true"
import script from "./EventTiers.vue?vue&type=script&lang=ts"
export * from "./EventTiers.vue?vue&type=script&lang=ts"
import style0 from "./EventTiers.vue?vue&type=style&index=0&id=65781c56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65781c56",
  null
  
)

export default component.exports